import React, { useState } from 'react';
import { ArrowRight, Send } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({ name: '', email: '', company: '', message: '' });
  };

  return (
    <section id="contact" className="py-24 md:py-32 bg-[#0a0a0a] text-white relative overflow-hidden">
      {/* Gradient blob */}
      <div className="absolute top-0 left-0 w-[60%] h-[80%] opacity-30 pointer-events-none">
        <div
          className="w-full h-full"
          style={{
            background: `
              radial-gradient(ellipse 60% 50% at 20% 30%, rgba(100, 200, 255, 0.3) 0%, transparent 50%),
              radial-gradient(ellipse 50% 50% at 40% 60%, rgba(180, 100, 255, 0.2) 0%, transparent 50%)
            `,
            filter: 'blur(80px)'
          }}
        />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-16 md:gap-24">
          {/* Left side - CTA */}
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light mb-8 leading-tight">
              Ready to stand out?
              <br />
              <span className="text-gray-500">Let's talk.</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 max-w-md">
              Got a project in mind? We'd love to hear about it. Drop us a line and let's create something extraordinary together.
            </p>
            <div className="space-y-4">
              <a
                href={`mailto:${companyInfo.email}`}
                className="block text-xl md:text-2xl text-white hover:text-gray-400 transition-colors duration-300"
              >
                {companyInfo.email}
              </a>
              <div className="flex gap-4 mt-8">
                <a
                  href={companyInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-white hover:text-black transition-colors duration-300"
                >
                  <span className="text-xs font-bold">FB</span>
                </a>
                <a
                  href={companyInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-white hover:text-black transition-colors duration-300"
                >
                  <span className="text-xs font-bold">IG</span>
                </a>
                <a
                  href={companyInfo.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center hover:bg-white hover:text-black transition-colors duration-300"
                >
                  <span className="text-xs font-bold">LI</span>
                </a>
              </div>
            </div>
          </div>

          {/* Right side - Form */}
          <div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="text"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full bg-transparent border-b border-gray-700 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-colors duration-300"
                  required
                />
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email address"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full bg-transparent border-b border-gray-700 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-colors duration-300"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Company name"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  className="w-full bg-transparent border-b border-gray-700 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-colors duration-300"
                />
              </div>
              <div>
                <textarea
                  placeholder="Tell us about your project"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  rows={4}
                  className="w-full bg-transparent border-b border-gray-700 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-colors duration-300 resize-none"
                  required
                />
              </div>
              <button
                type="submit"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-black rounded-full font-medium hover:bg-gray-200 transition-colors duration-300 mt-4"
              >
                {submitted ? (
                  <>Message sent!</>
                ) : (
                  <>Start your project <ArrowRight size={18} /></>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
